import { useEffect, useState, type RefObject } from 'react';

export const useTrackScrollEnd = ({ ref }: { ref: RefObject<HTMLElement | null> | undefined }) => {
  const [scrollEnd, setScrollEnd] = useState(0);

  useEffect(() => {
    const el = ref?.current;

    if (!el) return;

    const handleScrollEnd = () => {
      setScrollEnd((prev) => prev + 1);
    };

    el.addEventListener('scrollend', handleScrollEnd);

    return () => {
      el.removeEventListener('scrollend', handleScrollEnd);
    };
  }, [ref]);

  return scrollEnd;
};
